export var SearchResultVariant;
(function (SearchResultVariant) {
    SearchResultVariant["Recent"] = "RECENT";
    SearchResultVariant["Suggestion"] = "SUGGESTION";
    SearchResultVariant["Task"] = "TASK";
    SearchResultVariant["Project"] = "PROJECT";
    SearchResultVariant["ProjectGroup"] = "PROJECT_GROUP";
    SearchResultVariant["InternalTime"] = "INTERNAL_TIME";
})(SearchResultVariant || (SearchResultVariant = {}));
